import { Skeleton } from "../ui/skeleton";

export function ProfileSkeleton() {
  return (
    <div className="container flex h-full flex-col gap-4 px-2 py-4 md:p-4">
      <Skeleton className="h-full rounded-[20px] shadow-sm"></Skeleton>
    </div>
  );
}
